<template>
    <v-tooltip bottom>
        <template #activator="{ on, attrs }">
            <div
                class="test-submission-indicator"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon
                    size="16"
                    aria-hidden="true"
                >
                    mdi-test-tube
                </v-icon>
                <span class="test-text">{{ text }}</span>
            </div>
        </template>
        <span class="tooltip-capped">Submissions made here will be marked with type 'test' when viewing this form's submissions. Test submissions will not trigger downstream actions (add to lists, CRM syncs, etc).</span>
    </v-tooltip>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: "Test Mode",
        },
    },
};
</script>

<style scoped>
.test-submission-indicator {
    background: rgba(255, 193, 7, 1);
    color: #333;
    padding: 6px 10px;
    border-radius: 6px;
    cursor: default;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.2;
    display: flex;
    align-items: center;
    gap: 4px;
}
</style>
